import React from 'react';
import * as e from '../elements';

export const TutorialButton = (
  <e.PBlock height="content" width="" className="py-5">
    <div className="row">
      <div className="col-12 order-2 text-center col-sm-10 order-sm-1 text-sm-right py-3">
        <e.PText color="black-lo" text="" />
      </div>
      <div className="col-12 order-1 col-sm-2 order-sm-2 text-center py-3">
        <e.PText color="black-lo" text="Hint" />
      </div>
    </div>
  </e.PBlock>
);



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/TutorialButton.jsx